export const faqData = [
  {
    question: "Apa itu layanan riksa yang kami sediakan?",
    answer:
      "Layanan riksa kami mencakup berbagai bentuk pemeriksaan dan audit profesional, mulai dari inspeksi bangunan, audit lingkungan, hingga pengecekan keselamatan kerja. Semua dilakukan berdasarkan standar dan regulasi yang berlaku."
  },
  {
    question: "Siapa saja yang bisa menggunakan layanan ini?",
    answer:
      "Layanan kami terbuka untuk berbagai sektor — mulai dari instansi pemerintah, perusahaan swasta, pengembang properti, hingga masyarakat umum yang membutuhkan inspeksi profesional dan terpercaya."
  },
  {
    question: "Apakah hasil pemeriksaan kami bersifat resmi dan dapat digunakan secara legal?",
    answer:
      "Ya, seluruh hasil riksa kami didukung oleh dokumentasi resmi dan dapat digunakan untuk keperluan hukum, audit, sertifikasi, atau proses perizinan lainnya."
  },
  {
    question: "Berapa lama proses pemeriksaan biasanya berlangsung?",
    answer:
      "Waktu pemeriksaan tergantung pada jenis layanan dan skala proyek. Namun kami selalu mengutamakan efisiensi tanpa mengurangi ketelitian. Estimasi waktu akan dijelaskan di awal kerja sama."
  },
  {
    question: "Apakah layanan tersedia di seluruh wilayah Indonesia?",
    answer:
      "Saat ini kami melayani berbagai wilayah di Indonesia dengan prioritas pada area strategis. Untuk wilayah tertentu, silakan hubungi kami untuk informasi lebih lanjut."
  },
  {
    question: "Bagaimana cara memulai kerja sama?",
    answer:
      "Anda dapat menghubungi kami melalui halaman kontak atau mengisi formulir permintaan layanan. Tim kami akan segera menghubungi Anda untuk konsultasi awal dan penjadwalan inspeksi."
  },
  {
    question: "Apakah ada garansi atau jaminan atas layanan yang diberikan?",
    answer:
      "Kami berkomitmen terhadap akurasi dan profesionalitas. Jika ditemukan ketidaksesuaian dalam laporan, kami siap melakukan klarifikasi atau inspeksi ulang sesuai ketentuan."
  }
];
